var render = function (_h,_vm) {var _c=_vm._c;return _c('path',{attrs:{"d":"M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z","vector-effect":"non-scaling-stroke"}})}
var staticRenderFns = []

export { render, staticRenderFns }